<script setup>
const props = defineProps({
  label: {
    type: String,
    default: '<LABEL>',
  },
  value: {
    type: String,
    default: '<VALUE>',
  },
  info: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <li
    class="d-flex justify-content-between flex-column flex-560-row equal-base equal-base--tighter list-item"
  >
    <div class="list-item__label flex-shrink-0">
      {{ props.label }}
    </div>
    <div class="flex-fill list-item__value">
      {{ props.value }}
      <span
        v-if="props.info"
        class="equal-small-2 list-item__value-info"
      >{{
        props.info
      }}</span>
    </div>
  </li>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.list-item {
  border-bottom: 1px solid $color-dark-01;
  padding: 15px 0;

  &:first-child {
    border-top: 1px solid $color-dark-01;
  }

  &__label {
    padding-right: 0;
    margin-bottom: 8px;

    @include media-breakpoint-up(560) {
      width: 50%;
      padding-right: 20px;
      margin-bottom: 0;
    }
  }

  &__value {
    font-size: 20px;
    line-height: 24px;
  }

  &__value-info {
    display: block;
    color: $color-disabled;
    font-size: 16px;
    line-height: 19px;
  }
}
</style>
